// index.js
import { default as audiencesReducer } from './reducers';
export { default as audiencesOperations } from './operations';
export { default as audiencesTypes } from './types';
export default audiencesReducer;